import { i18n } from "@/i18n";
import { SIDENAV_GROUP_BY } from "@/constants";
import { useFlag } from "../../../composables/useFlags/useFlag";
import { buildOrgUrl } from "@/utils/navigation/orgUrl";

const safeBuildOrgUrl = (...args) => {
  if (typeof buildOrgUrl === "function") return buildOrgUrl(...args);
  const [orgType, orgUuid, suffix = ""] = args;
  const cleanSuffix =
    suffix && typeof suffix === "string"
      ? suffix.startsWith("/")
        ? suffix
        : `/${suffix}`
      : "";
  return orgUuid
    ? `/${orgType}/${orgUuid}${cleanSuffix}`
    : `/${orgType}${cleanSuffix}`;
};

const { isFeatureAvailable } = useFlag("MSP_BRANDING");

export const MSP_NAV_ITEMS = [
  {
    order: 7,
    groupBy: SIDENAV_GROUP_BY.DELTA,
    label: i18n.global.t("sidebar-settings"),
    icon: "cl-icon-tabler-settings",
    id: safeBuildOrgUrl("msp", null, "settings"),
    dataTestId: "msp-settings",
    children: [
      {
        label: i18n.global.t("Administrators"),
        id: safeBuildOrgUrl("msp", null, "settings/administrators"),
        dataTestId: "msp-settings-administrators",
      },
      ...(isFeatureAvailable.value
        ? [
            {
              label: i18n.global.t("sidebar-branding"),
              id: safeBuildOrgUrl("msp", null, "settings/branding"),
              dataTestId: "msp-settings-branding",
              permanentPill: {
                variant: "info",
                text: i18n.global.t("status-new"),
              },
            },
          ]
        : []),
      {
        label: i18n.global.t("SAML SSO"),
        id: safeBuildOrgUrl("msp", null, "settings/saml-sso"),
        dataTestId: "msp-settings-saml-sso",
      },
    ],
  },
];
export const CUSTOMER_NAV_ITEMS = [
  {
    order: 7,
    groupBy: SIDENAV_GROUP_BY.DELTA,
    label: i18n.global.t("sidebar-settings"),
    icon: "cl-icon-tabler-settings",
    id: safeBuildOrgUrl("customer", null, "settings"),
    dataTestId: "customer-settings",
    children: [
      {
        label: i18n.global.t("Administrators"),
        id: safeBuildOrgUrl("customer", null, "settings/administrators"),
        dataTestId: "customer-settings-administrators",
      },

      {
        label: i18n.global.t("Connections"),
        id: safeBuildOrgUrl("customer", null, "settings/connections"),
        dataTestId: "customer-settings-connections",
      },
      {
        label: i18n.global.t("SAML SSO"),
        id: safeBuildOrgUrl("customer", null, "settings/saml-sso"),
        dataTestId: "customer-settings-saml-sso",
      },
    ],
  },
];

export default {};
